import ODAS from '@/utils/api/odas';

const UserAccount = {
  sendVerification: (type) => {
    return ODAS.get('api/confirm/account', {
      by: type
    });
  }
};

export default UserAccount;
